import { HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/core/helpers/cn";
import { Plus3Icon } from "@/shared/icons";

type Props = HTMLAttributes<HTMLButtonElement>;

export default function TransportWarehouseTransportAddButton({ className, ...rest }: Props) {
  const { t } = useTranslation("transportWarehouse");

  return (
    <button
      type="button"
      className={cn(
        "relative h-[15.75rem] flex flex-col items-center justify-center gap-3.5 p-2.5 bg-dark-800/20 rounded-[0.75rem] cursor-pointer",
        "text-10 font-bold uppercase text-white/50",
        "group overflow-clip",
        className,
      )}
      {...rest}
    >
      <div
        className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity"
        style={{
          background:
            "linear-gradient(116deg, rgba(45, 190, 100, 0.10) 0%, rgba(24, 24, 24, 0.00) 100%)",
        }}
      />
      <Plus3Icon
        size={38}
        className="z-1 text-white/50 group-hover:text-accent-muted transition-[color]"
      />
      <div className="z-1 text-10 font-bold text-white/50 group-hover:text-white uppercase transition-[color]">
        {t("transportWarehouse.addTransport")}
      </div>
    </button>
  );
}
